import { requireService } from '@repo/di-ez';
import { GRID_ROW_NUMBER_COL_DEF, type GridColDef } from '@repo/go-table';
import { runInAction } from 'mobx';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import type { FactTrajectoryPointEntity } from '../../../service/entities';
import { getTrajectoryColumnHeaderTKey } from '../utils/get-column-header-t-key';

const TRAJECTORY_DATA_FIELDS = [
  'md',
  'inc',
  'azMag',
  'azTrue',
  'tvd',
  'ns',
  'we',
  'tvdss',
  'northing',
  'easting',
  'closure',
  'vsec',
  'ahd',
  'dls',
  'tfo',
] as const;

export const useTrajectoryColumns = (useShortColumnHeaders = true): GridColDef[] => {
  const { t } = useTranslation();

  return useMemo((): GridColDef[] => {
    const baseColumn: Partial<GridColDef<FactTrajectoryPointEntity>> = {
      headerAlign: 'left',
      editable: false,
      minWidth: 100,
      resizable: true,
      valueGetter: (_, row, column) => {
        return runInAction(() => row.data[column.field as keyof typeof row.data] ?? null);
      },
    };

    const dataColumns = TRAJECTORY_DATA_FIELDS.map((field) => ({
      ...baseColumn,
      field,
      type: 'number' as const,
      headerName: t(getTrajectoryColumnHeaderTKey(field, useShortColumnHeaders)),
    }));

    return [
      {
        ...GRID_ROW_NUMBER_COL_DEF,
      },
      ...dataColumns,
    ];
  }, [t, useShortColumnHeaders]);
};
